/* eslint-disable react/jsx-no-target-blank */
import React, { useEffect } from "react";
import { connect } from "react-redux";
import { withRouter, Link } from "react-router-dom";
import Footer from "../../common/components/Footer";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";

import WhiteLogo from "../../assets/logo-white.png";

import image1 from "./Assets/Group2.png";
import image2 from "./Assets/Group1.png";
import challenge1 from "./Assets/challenge1.jpg";
import challenge2 from "./Assets/challenge2.jpg";
import challenge3 from "./Assets/challenge3.jpg";
import challenge4 from "./Assets/challenge4.jpg";
import challenge5 from "./Assets/challenge5.jpg";
import challenge6 from "./Assets/challenge6.jpg";
import challenge7 from "./Assets/challenge7.jpg";
import challenge8 from "./Assets/challenge8.jpg";
import challenge9 from "./Assets/challenge9.jpg";
import helmet from "../../assets/landingpage/helmets.png";
import shoe1 from "../../assets/landingpage/ShoeNorm.jpg";
import glogo from "../../assets/landingpage/Glogo.svg";
import srlogo from "../../assets/landingpage/SRlogo.svg";
import slider1 from "../../assets/landingpage/slider1.jpg";
import slider2 from "../../assets/landingpage/slider2.jpg";
import slider3 from "../../assets/landingpage/slider3.jpg";
import slider4 from "../../assets/landingpage/slider4.jpg";
import slider5 from "../../assets/landingpage/slider5.jpg";
import slider6 from "../../assets/landingpage/slider6.jpg";
import slider7 from "../../assets/landingpage/slider7.jpg";
import slider8 from "../../assets/landingpage/slider8.jpg";
import grid from "../../assets/landingpage/grid.png";
import grid2 from "../../assets/landingpage/grid2.png";
import Video1 from "../../assets/landingpage/LandingVid.mp4";
import Video2 from "../../assets/landingpage/LandingVid2.mp4";

import PC from "./Assets/Macbook.png";

import { compose } from "recompose";
import { Button } from "antd";

import { Row } from "antd";
import { Col } from "antd";

import "antd/dist/antd.css";
import "inter-ui/inter.css";
import "./LandingPage.scss";
import FadeIn from "react-fade-in";
import Aos from "aos";
import "aos/dist/aos.css";

const responsive = {
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 8,
  },
};

const LandingPage = ({ authUser, history }) => {
  useEffect(() => {
    if (authUser) {
      history.push("/s2r");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    Aos.init({
      duration: 3000,
      delay: 200,
    });
  }, []);

  return (
    <div className="content-container2">
      <FadeIn delay={300}>
        <div
          className="row landing-nav-bar"
          style={{ padding: 10, paddingTop: 50 }}
        >
          <Link to="/">
            <img src={WhiteLogo} />
          </Link>
          <Link to="/signin">
            <Button
              className="sign-up-btn"
              type="primary"
              style={{ backgroundColor: "#447ce9" }}
            >
              Sign up
            </Button>
          </Link>
          <Link to="/signin">
            <p>Log in</p>
          </Link>
          <Link to="/pricing">
            <p className="hvr-shrink">Plans & Pricing</p>
          </Link>
        </div>
      </FadeIn>

      <div className="row">
        <div className="col s12 m12 l12 landing-banner">
          <FadeIn delay={500}>
            <h1
              style={{
                fontSize: "24px",
                paddingTop: "25%",
              }}
            >
              We're reimagining the way
              <br /> artist and designers
              <span className="gradient-create"> create.</span>
            </h1>
            <p style={{ paddingBottom: "15%" }}>
              {" "}
              Ai enabled creative tools — all on the web.
            </p>
            <div className="row intro-btn-container">
              <div className="col s12 m12 l12 center-me">
                <Link to="/pricing">
                  <Button className="get-started hvr-shrink" type="primary">
                    Get Started
                  </Button>
                </Link>
              </div>
            </div>
          </FadeIn>
        </div>
      </div>

      <div>
        {/* <img alt="pc" src={PC} /> */}
        <video
          muted
          loop
          autostart="true"
          playsInline
          autoPlay
          src={Video1}
          type="video/mp4"
          style={{ width: "100%", paddingTop: "15%" }}
        />
      </div>

      <div
        data-aos="fade-up"
        className="row sk2r-demo"
        style={{
          backgroundColor: "#111015",
          paddingTop: "10%",
          paddingBottom: "10%",
        }}
      >
        <div
          className="row"
          style={{
            borderBottom: "solid 1px #535353",
            paddingBottom: "10%",
            margin: "5%",
            backgroundImage: `url(${grid})`,
          }}
        >
          <div className="col s12 m12 l12 ">
            <h1
              style={{
                fontWeight: 800,
                color: "#6677E1",
                fontSize: "120px",
              }}
            >
              <img src={srlogo} style={{ float: "left", width: "25px" }} />
              S2R
            </h1>
          </div>
          <div className="col s12 m12 l12 ">
            <h1 style={{ padding: "0", fontSize: "3rem" }}>
              Turn hours into seconds.
            </h1>
            <p style={{ padding: 0 }}>
              SketchtoRender(S2R) renders fast. Really fast. Thanks to the power
              artificial intelligence. S2R is designed to keep you working at
              the pace you want — all in your browser.
            </p>
          </div>
        </div>
        <img
          src={helmet}
          style={{
            marginLeft: "auto",
            marginRight: "auto",
            display: "block",
            paddingTop: "5%",
          }}
        />
        <Link to="/signin">
          <Button
            style={{
              marginLeft: "auto",
              marginRight: "auto",
              display: "block",
              marginTop: "5rem",
              borderRadius: "12rem",
              border: "none",
              backgroundColor: "transparent",
              border: "solid 2px white",
              height: "50px",
              width: "300px",
              fontSize: "1rem",
            }}
            type="primary"
          >
            Get started for free
          </Button>
        </Link>
      </div>

      <div className="row ">
        <div style={{ paddingTop: "10%" }}>
          <p
            style={{
              color: "#959595",
              textAlign: "center",
              fontFamily: "Inter",
              fontSize: "20px",
              padding: "5%",
            }}
          >
            Rendered using S2R
          </p>
          <Carousel
            responsive={responsive}
            draggable={true}
            infinite={true}
            itemClass="test"
            containerClass="carousel-container"
          >
            <div>
              <img src={slider1} />
            </div>
            <div>
              <img src={slider2} />
            </div>
            <div>
              <img src={slider3} />
            </div>
            <div>
              <img src={slider4} />
            </div>
            <div>
              <img src={slider5} />
            </div>
            <div>
              <img src={slider6} />
            </div>
            <div>
              <img src={slider7} />
            </div>
            <div>
              <img src={slider8} />
            </div>
          </Carousel>
        </div>
        <Link to="/signin">
          <Button
            style={{
              marginLeft: "auto",
              marginRight: "auto",
              display: "block",
              marginTop: "5rem",
              borderRadius: "12rem",
              border: "none",
              backgroundColor: "transparent",
              border: "solid 2px white",
              height: "50px",
              width: "300px",
              fontSize: "1rem",
            }}
            type="primary"
          >
            Get started for free
          </Button>
        </Link>
      </div>

      <div className="row quote2">
        <img
          src={srlogo}
          style={{
            paddingTop: "10%",
            width: "50px",
            marginBottom: "2%",
            marginTop: "2%",
          }}
        />
        <h2 style={{ padding: 0 }}>See your ideas come to life</h2>
        <p>
          Thanks to the power artificial intellegence, S2R is able to render as
          fast as you draw, paint or sketch. Designed to keep you working at the
          pace you want.
        </p>
        <div
          style={{
            display: "block",
          }}
        >
          <img style={{ width: "100%" }} src={shoe1} />
        </div>
      </div>
      <div className="row quote2">
        <h2 style={{ paddingTop: "15%", fontWeight: 500 }}>All on the web</h2>

        <img
          src={PC}
          style={{
            width: 375,
            height: "auto",
            marginLeft: "auto",
            marginRight: "auto",
            padding: "2rem",
          }}
        />
        <Link to="/signin">
          <Button
            style={{
              marginLeft: "auto",
              marginRight: "auto",
              display: "block",
              marginTop: "5rem",
              borderRadius: "12rem",
              border: "none",
              backgroundColor: "transparent",
              border: "solid 2px white",
              height: "50px",
              width: "300px",
              fontSize: "1rem",
            }}
            type="primary"
          >
            Get started for free
          </Button>
        </Link>
      </div>
      <div
        className="row sk2r-demo"
        style={{ backgroundColor: "#111015", paddingBottom: "10%" }}
      >
        <div
          className="row"
          style={{
            borderBottom: "solid 1px #535353",
            margin: "5%",
            paddingBottom: "15%",
            paddingTop: "10%",
            backgroundImage: `url(${grid2})`,
          }}
        >
          <div className="col s6 m6 l6 ">
            <h1
              style={{
                fontWeight: 800,
                color: "#66DFA5",
                fontSize: "50px",
              }}
            >
              <img src={glogo} style={{ float: "left", width: "30px" }} />
              Generator
            </h1>
          </div>
          <div className="col s12 m12 l12 ">
            <h1 style={{ padding: 0 }}>Generate Creative Inspiration</h1>
            <p style={{ padding: 0 }}>
              Generate and explore synthesized images for creative inspiration.
            </p>
          </div>
        </div>
        <div className="demo-video">
          {/* <img alt="pc" src={PC} /> */}
          <video
            muted
            loop
            autostart="true"
            playsInline
            autoPlay
            src={Video2}
            type="video/mp4"
            style={{ width: "375px" }}
          />
        </div>
        <Link to="/signin">
          <Button
            style={{
              marginLeft: "auto",
              marginRight: "auto",
              display: "block",
              marginTop: "5rem",
              borderRadius: "12rem",
              border: "none",
              backgroundColor: "transparent",
              border: "solid 2px white",
              height: "50px",
              width: "300px",
              fontSize: "1rem",
            }}
            type="primary"
          >
            Get started for free
          </Button>
        </Link>
      </div>
      <div className="row quote2">
        <h2 style={{ padding: "5%", paddingTop: "25%" }}>
          Ai that assist artist in
          <span className="creative-thinking"> creative thinking.</span>
        </h2>

        <img alt="logo" src={image1} style={{ width: "100%", padding: "5%" }} />
      </div>

      <div style={{ margin: "15%" }}>
        <h1
          style={{
            fontSize: "30px",
            textAlign: "center",
            color: "white",
            fontFamily: "Inter",
          }}
        >
          Work derived from <span style={{ color: "#66DFA5" }}>Generator</span>
        </h1>
        <Row gutter={[8, 8]} className="gallery">
          <Col span={8}>
            {" "}
            <a href="https://www.instagram.com/p/CR6Dv4-pWmd/" target="_blank">
              <img alt="challenge" src={challenge1} />
            </a>{" "}
          </Col>
          <Col span={8}>
            {" "}
            <a href="https://www.instagram.com/p/CR6Dv4-pWmd/" target="_blank">
              <img alt="challenge" src={challenge2} />{" "}
            </a>
          </Col>
          <Col span={8}>
            {" "}
            <a href="https://www.instagram.com/p/CMHozlKHIZc/" target="_blank">
              <img alt="challenge3" src={challenge3} />
            </a>
          </Col>
          <Col span={8}>
            {" "}
            <a href="https://www.instagram.com/p/CNc6RIHpRok/" target="_blank">
              <img alt="challenge4" src={challenge4} />
            </a>
          </Col>
          <Col span={8}>
            {" "}
            <a href="https://www.instagram.com/p/CR6Dv4-pWmd/" target="_blank">
              <img alt="challenge" src={challenge5} />
            </a>
          </Col>
          <Col span={8}>
            {" "}
            <a href="https://www.instagram.com/p/CFZoVjuJ-4G/" target="_blank">
              <img alt="challenge" src={challenge6} />
            </a>
          </Col>
          <Col span={8}>
            {" "}
            <a href="https://www.instagram.com/p/CHhoKkOJI2Y/" target="_blank">
              <img alt="challenge" src={challenge7} />
            </a>
          </Col>
          <Col span={8}>
            {" "}
            <a
              href="https://twitter.com/Vizcom_co/status/1384746699827007492"
              target="_blank"
            >
              <img alt="challenge" src={challenge8} />
            </a>
          </Col>
          <Col span={8}>
            {" "}
            <a href="https://www.instagram.com/p/CMK5J-QFCVx/" target="_blank">
              <img alt="challenge" src={challenge9} />
            </a>
          </Col>
        </Row>
        <Link to="/signin">
          <Button
            style={{
              marginLeft: "auto",
              marginRight: "auto",
              display: "block",
              marginTop: "5rem",
              borderRadius: "12rem",
              border: "none",
              backgroundColor: "transparent",
              border: "solid 2px white",
              height: "50px",
              width: "300px",
              fontSize: "1rem",
            }}
            type="primary"
          >
            Get started for free
          </Button>
        </Link>
      </div>

      <div className="footer-box row">
        <div className="col s12 m12 l12">
          <h1 style={{ fontSize: "24px" }}>
            On a mission to build the next generation of creative tools.
          </h1>
        </div>
        <div className="col s12 m12 l12">
          <img alt="challenge" src={image2} style={{ width: "100%" }} />
        </div>
      </div>
      <div style={{ backgroundColor: "#fafafa" }}>
        <Footer />
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  authUser: state.session.authUser,
});

export default compose(withRouter, connect(mapStateToProps))(LandingPage);
